export type BudgetThresholdState = "on-track" | "warning" | "over";

export function getBudgetThresholdState(
  spent: number,
  limit: number,
): BudgetThresholdState {
  if (limit <= 0) return "on-track";
  const pct = spent / limit;
  if (pct >= 1) return "over";
  if (pct >= 0.9) return "warning";
  return "on-track";
}

export function thresholdBarClass(state: BudgetThresholdState): string {
  switch (state) {
    case "over":
      return "bg-danger-400";
    case "warning":
      return "bg-warning-400";
    case "on-track":
      return "bg-success-400";
  }
}

export function thresholdTextClass(state: BudgetThresholdState): string {
  switch (state) {
    case "over":
      return "text-danger-600 dark:text-danger-400";
    case "warning":
      return "text-warning-600 dark:text-warning-400";
    case "on-track":
      return "text-success-600 dark:text-success-400";
  }
}

export function thresholdBgClass(state: BudgetThresholdState): string {
  switch (state) {
    case "over":
      return "bg-danger-50 dark:bg-danger-900/30";
    case "warning":
      return "bg-warning-50 dark:bg-warning-900/30";
    case "on-track":
      return "bg-success-50 dark:bg-success-900/30";
  }
}
